import {MatDialogConfig} from '@angular/material/dialog';

export const DefaultDialogConfig: MatDialogConfig = {
  maxWidth: '500px',
  width: '80vw',
  maxHeight: '100vh',
};
